import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { FAILURE_USERS, REQUEST_USERS, SUCCESS_USERS } from 'src/store/users/actions';

export function usersReducer(state: EntityCollectionState<any> = entityCollectionDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_USERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_USERS: {
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        }
        case FAILURE_USERS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
